import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { translations } from "../../utils/translations";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import { LuPhone } from "react-icons/lu";
import { FiMail } from "react-icons/fi";
import { BsMailboxFlag } from "react-icons/bs";
import { Link } from "react-router-dom";
import { SlLocationPin } from "react-icons/sl";

const FullFooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5%;
  width: 95%;
  padding: 20px 0;
`;


const ANPCContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 5%;
  width: 100%;
  border-top: 2px solid var(--white-gray-color);
  padding: 20px 0;
`;
const ColumnContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;
const SectionTitle = styled.div`
  color: var(--secondary-font-color);
  font-weight: bold;
  font-size: 1rem;
  font-family: Georgia, serif;
`;
const SectionDescription = styled.div`
  color: var(--tertiary-font-color);
  font-size: 0.75rem;
  font-family: Verdana, sans-serif;
  text-align: center;
  width: 100%;
`;
interface SectionProps {
  direction?: string;
}

const Section = styled.div<SectionProps>`
  padding-top: 10px;
  color: var(--tertiary-font-color);
  font-size: 0.875rem;
  font-family: Verdana, sans-serif;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => props.direction || "column"};
  gap: 4px;
  justify-content: center;

  a {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    color: inherit;
    text-decoration: none;
    cursor: pointer;

    svg {
      font-size: 1.2rem;
    }
  }
  a:visited {
    color: inherit;
  }

  a:hover {
    color: var(--secondary-font-color);
  }
`;

interface Props {
  isMobile: boolean;
}

const Footer: React.FC<Props> = ({ isMobile }) => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);

  const sections = [
    {
      name: "footer-social-media-section-title",
      mobile: true,
      message: "footer-social-media-section-description",
      direction: "row",
      values: [
        {
          url: "https://www.facebook.com",
          icon: <FiFacebook />,
        },
        {
          url: "https://www.instagram.com",
          icon: <FiInstagram />,
        },
      ],
    },
    {
      name: "footer-support-section-title",
      mobile: false,
      direction: "column",
      values: [
        { name: "0724702368", url: "tel:0724702368", icon: <LuPhone /> },
        {
          name: "contact@filoprint.ro",
          url: "mailto:contact@filoprint.ro",
          icon: <FiMail />,
        },
        { name: "Contact", url: "/support", icon: <BsMailboxFlag /> },
        { name: "Sector 6, București", url: undefined, icon: <SlLocationPin /> },
      ],
    },
    {
      name: "footer-utils-section-title",
      mobile: true,
      direction: "column",
      values: [
        { name: "footer-retur-section", url: "/retur" },
        { name: "footer-pay-section", url: "/transport-payment" },
        { name: "footer-terms-section", url: "/terms" },
      ],
    },
  ];

  return (
        <FullFooterContainer>
    <FooterContainer>
      {sections.map((section) => {
        if (!section.mobile && isMobile) return null;
        return (
          <ColumnContainer key={section.name}>
            <SectionTitle>
              {translations[languageCode][section.name] ?? section.name}
            </SectionTitle>
            {section.message && (
              <SectionDescription>
                {translations[languageCode][section.message] ?? section.message}
              </SectionDescription>
            )}
            <Section direction={section.direction}>
              {section.values.map((value) => (
                <Link key={value.url} to={value.url}>
                  {value.icon}
                  {translations[languageCode][value.name] ?? value.name}
                </Link>
              ))}
            </Section>
          </ColumnContainer>
        );
      })}
    </FooterContainer>

    <ANPCContainer>
       <a aria-label="Ce este sal?" href="https://anpc.ro/ce-este-sal/" rel="nofollow" target="_blank">                 
        <img  src={"/images/solutionare_litigii_200x.png"}   loading="lazy" />
        </a>

          <a aria-label="Customer ODR" href="https://ec.europa.eu/consumers/odr" rel="nofollow" target="_blank">                 
        <img  src={"/images/solutionare_online_200x.avif"}   loading="lazy"  />
        </a>

     

    </ANPCContainer>
        </FullFooterContainer>
  );
};

export default Footer;
